export * from "/builds/dd3tech/wiggot/wiggot-web/packages/web-components/components/nav-bar-home/nav-bar-home/NavbarHome.tsx"